var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "booking-form-frontpage" }, [
    _c("div", { attrs: { id: "booking-form-bottom" } }, [
      _c("div", { staticClass: "inputrow" }, [
        _c(
          "div",
          {
            staticClass: "inputrowitemlocation",
            attrs: { id: "pickupLocation" },
          },
          [
            _c("location-control-version2", {
              attrs: {
                bookViewFilter: true,
                value: _vm.pickUpLocationId,
                locations: _vm.locations,
                active: _vm.selectPickUpLocation,
                label: _vm.pickUpLocationLabel,
              },
              on: { "update-location": _vm.updatePickupLocation },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "inputrowitemdatetime date" },
          [
            _c("date-time-input-separated", {
              attrs: {
                datelabel: _vm.pickUpDateLabel,
                timelabel: _vm.pickUpTimeLabel,
                widgetType: 0,
                bookViewFilter: true,
                minDate: _vm.minDate,
                location: _vm.pickupLocation,
                id: "pickUpDateTimeInput",
              },
              on: { "update-date": _vm.updatePickupDateTime },
              model: {
                value: _vm.pickUpDateTime,
                callback: function ($$v) {
                  _vm.pickUpDateTime = $$v
                },
                expression: "pickUpDateTime",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "inputrow" }, [
        _c(
          "div",
          { staticClass: "inputrowitemlocation" },
          [
            _c("location-control-version2", {
              attrs: {
                bookViewFilter: true,
                value: _vm.returnLocationId,
                locations: _vm.locations,
                active: _vm.selectReturnLocation,
                label: _vm.returnLocationLabel,
              },
              on: { "update-location": _vm.updateReturnLocation },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "inputrowitemdatetime time" },
          [
            _c("date-time-input-separated", {
              attrs: {
                widgetType: 1,
                bookViewFilter: true,
                datelabel: _vm.returnDateLabel,
                timelabel: _vm.returnTimeLabel,
                minDate: _vm.pickUpDateTime,
                location: _vm.returnLocation,
                id: "returnDateTimeInput",
              },
              on: {
                click: function ($event) {
                  return _vm.beginSelectReturnDateTime()
                },
                focus: function ($event) {
                  return _vm.beginSelectReturnDateTime()
                },
                "update-date": _vm.updateReturnDateTime,
              },
              model: {
                value: _vm.returnDateTime,
                callback: function ($$v) {
                  _vm.returnDateTime = $$v
                },
                expression: "returnDateTime",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "button",
          {
            staticClass: "option-footer-button",
            attrs: { disabled: !_vm.canFetchQuotes },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.fetchQuotes()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("message.showCars")) + " ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }